export const dataSkills1 = [
    'HTML',
    'CSS',
    'Bootstrap',
    'JavaScript',
    'React',
    'C',
    'Cplusplus',
    'Firebase',
    'MongoDB',
    'MySQL',
    'NodeJS',
    // 'nextjs',
    'Figma',
    'Git',
]